export default "__VITE_ASSET__DqFnxtgb__"